import React, { useState } from "react";

/* ══ SMART HOME SCENES ════════════════════════════════════
   Scene list with trigger buttons. Scenes are read from HA
   via the useHomeAssistant hook (scene domain entities).
   Triggering calls scene.turn_on via WS.                   */

function SmartHomeScenes({ scenes, triggerScene, canControl, isRTL }) {
  const [triggered, setTriggered] = useState(null);

  function handleTrigger(sceneId) {
    if (!canControl) return;
    triggerScene(sceneId);
    setTriggered(sceneId);
    setTimeout(() => setTriggered(null), 2000);
  }

  if (!scenes.length) return (
    <div className="sh-scenes-empty">
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" stroke="var(--g300)" strokeWidth="1.3">
        <rect x="4" y="8" width="32" height="24" rx="3"/><path d="M4 14h32"/><circle cx="12" cy="24" r="4"/><circle cx="28" cy="24" r="4"/><path d="M16 24h8"/>
      </svg>
      <p>{isRTL ? "لا توجد مشاهد في Home Assistant" : "No scenes found in Home Assistant."}</p>
      <p className="sh-scenes-hint">{isRTL ? "أنشئ مشاهد في HA لتظهر هنا" : "Create scenes in HA to see them here."}</p>
    </div>
  );

  return (
    <div className="sh-scenes">
      <div className="sh-scenes-grid">
        {scenes.map(scene => {
          const active = triggered === scene.entity_id;
          return (
            <button
              key={scene.entity_id}
              className={`sh-scene-card${active ? " sh-scene-triggered" : ""}`}
              disabled={!canControl}
              onClick={() => handleTrigger(scene.entity_id)}
            >
              <div className="sh-scene-icon">
                {scene.icon
                  ? <span style={{ fontSize: 20 }}>{scene.icon.startsWith("mdi:") ? "🎬" : scene.icon}</span>
                  : <svg width="20" height="20" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.3"><rect x="2" y="4" width="16" height="12" rx="2"/><path d="M2 8h16"/><circle cx="7" cy="13" r="2"/><circle cx="13" cy="13" r="2"/></svg>
                }
              </div>
              <span className="sh-scene-name">{scene.friendly_name}</span>
              {active && <span className="sh-scene-flash">{isRTL ? "تم!" : "Triggered!"}</span>}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export default SmartHomeScenes;
